export const qrCodeConstants = {
    POST_DECRYPT_DATA_REQUEST: "POST_DECRYPT_DATA_REQUEST",
    POST_DECRYPT_DATA_SUCCESS: "POST_DECRYPT_DATA_SUCCESS",
    POST_DECRYPT_DATA_FAILURE: "POST_DECRYPT_DATA_FAILURE",
  };
  